var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('Dialog',{key:item.key,attrs:{"item":item},on:{"close":_vm.onClose}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }